import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { Formik } from "formik";
import ReactSVG from "react-svg";
import {
  checkHasNumber,
  checkHasString,
  checkHasSpecialCharacter,
} from "~/utils/tools";

import {
  Margin,
  Input,
  Button,
  Loading,
  Alert,
  Text,
} from "~/components/elements";
import * as S from "./styles";
import { schema } from "./validation";

import errorSVG from "~/assets/img/icon/error.svg";
import successSVG from "~/assets/img/icon/check.svg";

import isMobile from "~/hooks/isMobile";

import { Creators as AccountActions } from "~/store/modules/account/actions";

export default function FormUpdatePassword({setEditSenha}) {
  const dispatch = useDispatch();
  const mobile = isMobile();
  const location = useLocation();

  const sending = useSelector((state) => state.account.password.sending);

  const errorMessage = useSelector(
    (state) => state.account.password.errorMessage
  );

  const initialValues = {
    Password: "",
    NewPassword: "",
    ConfirmPassword: "",
  };

  // const urlStorage = localStorage.getItem("url");
  // const url = urlStorage !== "null" ? urlStorage : window.location.origin;

  const url = process.env.REACT_APP_HOST_URL;
  const origin = process.env.REACT_APP_ORIGIN;

  return (
    <S.FormHolder>
      <Margin mb={8}>
        <Formik
          initialValues={initialValues}
          validationSchema={schema}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(false);
            dispatch(
              AccountActions.sendPassword({
                url: url,
                origin: origin,
                SenhaAntiga: values.Password,
                Senha: values.NewPassword,
                SenhaNovamente: values.ConfirmPassword,
              }, ()=> {setEditSenha(false)})
            );
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isValid,
            dirty,
          }) => (
            <S.FormLimiter onSubmit={handleSubmit}>
              <Margin mb={2}>
                <Input
                  label="Senha atual"
                  placeholder="Digite sua senha atual"
                  htmlFor="passwordFieldFormUpdatePassword"
                  name="Password"
                  type="password"
                  value={values.Password}
                  errors={errors.Password && touched.Password && errors.Password}
                  onChange={handleChange}
                  successIcon={true}
                  showHidePassword={true}
                  onBlur={handleBlur}
                  validateOnBlur={false}
                  showPassword={false}
                  required
                />
              </Margin>
              <Margin mb={2}>
                <S.ForgotLink>
                  <Link
                    to={`/esqueci-minha-senha${location.search}`}
                    id="forgotLinkFormUpdatePassoword"
                  >
                    Esqueci minha senha
                  </Link>
                </S.ForgotLink>
              </Margin>

              <Margin mb={2}>
                <Input
                  label="Nova senha"
                  placeholder="Digite sua nova senha"
                  htmlFor="newPasswordFieldFormUpdatePassword"
                  name="NewPassword"
                  type="password"
                  value={values.NewPassword}
                  errors={errors.NewPassword && touched.NewPassword && errors.NewPassword}
                  onChange={handleChange}
                  showHidePassword={true}
                  successIcon={true}
                  hideError={true}
                  validateOnBlur={false}
                  required
                />
              </Margin>

              <Margin mb={2}>
                <Input
                  label="Confirme a nova senha"
                  placeholder="Digite sua nova senha novamente"
                  htmlFor="confirmNewPasswordFieldFormUpdatePassword"
                  name="ConfirmPassword"
                  type="password"
                  value={values.ConfirmPassword}
                  onChange={handleChange}
                  successIcon={true}
                  showHidePassword={true}
                  hideError={true}
                  validateOnBlur={false}
                  required
                />
              </Margin>

              <S.PasswordRules>
                <Text level="1">Sua senha deve conter:</Text>
                <ul>
                  <li
                    className={
                      values.NewPassword.length === 0 ||
                      values.NewPassword !== values.ConfirmPassword
                        ? "error"
                        : ""
                    }
                  >
                    <ReactSVG
                      src={
                        values.NewPassword.length === 0 ||
                        values.NewPassword !== values.ConfirmPassword
                          ? errorSVG
                          : successSVG
                      }
                    />
                    Deve conter a mesma senha nos campos Nova senha e Confirmar
                    a nova senha.
                  </li>
                  <li
                    className={
                      values.NewPassword.length < 8 ||
                      values.NewPassword.length >= 32
                        ? "error"
                        : ""
                    }
                  >
                    <ReactSVG
                      src={
                        values.NewPassword.length < 8 ||
                        values.NewPassword.length >= 32
                          ? errorSVG
                          : successSVG
                      }
                    />
                    Mínimo 8 e máximo 32 caracteres.
                  </li>
                  <li
                    className={
                      !checkHasString(values.NewPassword) ? "error" : ""
                    }
                  >
                    <ReactSVG
                      src={
                        !checkHasString(values.NewPassword)
                          ? errorSVG
                          : successSVG
                      }
                    />
                    Pelo menos uma letra.
                  </li>
                  <li
                    className={
                      !checkHasNumber(values.NewPassword) ? "error" : ""
                    }
                  >
                    <ReactSVG
                      src={
                        !checkHasNumber(values.NewPassword)
                          ? errorSVG
                          : successSVG
                      }
                    />
                    Pelo menos um número.
                  </li>
                  <li
                    className={
                      !checkHasSpecialCharacter(values.NewPassword)
                        ? "error"
                        : ""
                    }
                  >
                    <ReactSVG
                      src={
                        !checkHasSpecialCharacter(values.NewPassword)
                          ? errorSVG
                          : successSVG
                      }
                    />
                    Pelo menos um caractere especial (Ex: !#@).
                  </li>
                </ul>
              </S.PasswordRules>
              <S.ButtonsGrid
                container
                justifyContent="space-between"
                direction={mobile ? "column-reverse" : "row"}
              >
                <Button
                  className="animation-size"
                  color={!isValid || !dirty || sending ? "disabled" : "primary"}
                  type="submit"
                  disabled={!isValid || !dirty || sending}
                  id="sendButtonFormUpdatePassword"
                >
                  {sending ? <Loading button /> : "SALVAR NOVA SENHA"}
                </Button>
              </S.ButtonsGrid>
            </S.FormLimiter>
          )}
        </Formik>
        {errorMessage && (
          <Margin mt={3} mb={3}>
            <Alert type="error">{errorMessage}</Alert>
          </Margin>
        )}
      </Margin>
    </S.FormHolder>
  );
}
